exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".booking-information>.booking-confirmation .main-message[data-v-ba607522]{color:red}.travel-ideas .idea-title .index[data-v-ba607522]{background:red}.booking-information>.booking-confirmation>.icon[data-v-ba607522]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ba607522","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checkout/abort/Abort.vue
// module id = 546
// module chunks = 0